module.exports = __webpack_public_path__ + "img/2020年度企业社会责任先锋奖.f73f49a1.jpg";